import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ReclamationWorkQueuePage } from "src/components/views/erp/reclamation/workQueue/ReclamationWorkQueuePage.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/erp/reclamations/workQueue")({
	staticData: { title: i18n.t("reclamation_work_queue"), legacyViewKey: "reclamationWorkQueuePage" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <ReclamationWorkQueuePage isActive={isActive} />;
}
